import request from "../axios/axios";
import {
  CalculationRequestInterface,
  CalculationResponseInterface,
} from "../entities/Calculation";
import { AxiosMethod } from "../entities/Environment";

export enum CalculationEndpoints {
  GET_CALCULATION = "/engine/",
}

export class CalculationService {
  static getCalculatedPricesAndVolume(
    data: CalculationRequestInterface,
  ): Promise<CalculationResponseInterface> {
    return request({
      url: CalculationEndpoints.GET_CALCULATION,
      method: AxiosMethod.POST,
      data,
    });
  }
}
